import React, { useCallback } from 'react';
import { LinePath } from '@visx/shape';

function ItemTrend({
  qsKey,
  qKey,
  data,
  text,
  paletteMap,
  x,
  y,
  curve,
  generateKey = () => '',
  onMouseOut = () => {},
  onMouseOver = () => {},
}) {
  const handleMouseOver = useCallback(() => {
    onMouseOver(qsKey, qKey, text);
  }, [onMouseOver, qsKey, qKey, text]);

  if (!data) {
    return null;
  }

  const key = generateKey(qsKey, qKey);

  return (
    <g key={key} className={`line ${paletteMap[key]?.className} palette-muted`}>
      <LinePath
        className="palette-stroke"
        curve={curve}
        x={x}
        y={y}
        data={data}
        onMouseOver={handleMouseOver}
        onMouseOut={onMouseOut}
      />
      <g>
        {data.map((d, i) => (
          <circle
            key={i}
            cx={x(d)}
            cy={y(d)}
            r="2"
            className="palette-fill"
            stroke="none"
          />
        ))}
      </g>
    </g>
  );
}

export default ItemTrend;
